import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PreparePlan = lazyWithPreload(() => import('./PreparePlan'))
